import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { getModuleTypesAsync, uploadCourseAsync } from '../../../../Services/CourseService';
import Upload from './Components/Upload';
import Header from './../../../../Shared/Components/Header/Header';
import Card from './../../../../Shared/Components/Card/Card';

const UploadCourse = () => {
    const history = useHistory();
    const [moduleTypes, setModuleTypes] = useState([{ name: '', id: '' }]);
    const [state, setState] = useState({
        title: null,
        friendlyName: null,
        reference: null,
        description: null,
        hasAssessment: true
    });

    useEffect(() => {
        //get module types for dropdown
        const getModuleTypes = async () => {
            let response = await getModuleTypesAsync();
            setModuleTypes(response);
        }
        getModuleTypes();
    }, []);

    const [errors, setErrors] = useState([]);

    const handleChange = async evt => {
        const { name, value, type, checked } = evt.target;
        setState({ ...state, [name]: type === 'checkbox' ? checked : value });
    }

    const handleValidation = () => {
        let fields = state;
        let errors = {};
        let formIsValid = true;

        //title
        if (!fields["title"]) {
            formIsValid = false;
            errors["title"] = "Please enter a title";
        }

        //description
        if (!fields["description"]) {
            formIsValid = false;
            errors["description"] = "Please enter a description";
        }

        //reference
        if (!fields["reference"]) {
            formIsValid = false;
            errors["reference"] = "Please add a reference";
        }

        setErrors(errors);
        return formIsValid;
    }

    const handleSubmit = async () => {
        if (handleValidation()) {
            let form = new FormData();
            form.append("title", state.title);
            form.append("friendlyName", state.friendlyName ?? '');
            form.append("reference", state.reference);
            form.append("description", state.description);
            form.append("hasAssessment", state.hasAssessment ?? true);

            let response = await uploadCourseAsync(form);
            if (response.success) {
                history.push(`/course/${response.courseId}`);
            }
            else {
                alert("An error occurred uploading the course");
            }
        }
    }


    return (
        <>
            <Header heading="Create Course" subheading="Upload a course " icon="pencil-alt" />
            <div className="container-fluid content">
                <Card title="Create new">
                    <Upload
                        state={state}
                        handleChange={handleChange}
                        handleSubmit={handleSubmit}
                        errors={errors}
                    />
                </Card>
            </div>
        </>
    );
};

export default UploadCourse;